import { render } from "./ControlLabelBound.vue?vue&type=template&id=0f0ebb25&ts=true&lang=pug"
import script from "./ControlLabelBound.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlLabelBound.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__